import { createContext, useContext, useState, useCallback } from "react";

interface TourContextType {
  running: boolean;
  startTour: () => void;
  stopTour: () => void;
  stepIndex: number;
  setStepIndex: (index: number) => void;
}

const TourContext = createContext<TourContextType>({
  running: false,
  startTour: () => {},
  stopTour: () => {},
  stepIndex: 0,
  setStepIndex: () => {},
});

export function TourProvider({ children }: { children: React.ReactNode }) {
  const [running, setRunning] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const startTour = useCallback(() => {
    setStepIndex(0);
    setRunning(true);
  }, []);

  const stopTour = useCallback(() => {
    setRunning(false);
    setStepIndex(0);
  }, []);

  return (
    <TourContext.Provider value={{ running, startTour, stopTour, stepIndex, setStepIndex }}>
      {children}
    </TourContext.Provider>
  );
}

export const useTour = () => useContext(TourContext);
